import { render } from "./TheHeadingRoundIndex.vue?vue&type=template&id=0c0f8797"
import script from "./TheHeadingRoundIndex.vue?vue&type=script&lang=js"
export * from "./TheHeadingRoundIndex.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__